// Regras de pontuacao do ClawETF, em UM lugar so.
// Motivo: o Premium Score ja teve duas copias escritas a mao que divergiram
// com o tempo. Aqui a mesma funcao serve o card e quem mais precisar
// (por exemplo o registro de analises, que grava o score para conferir depois).

// CLAW Confluence Score — placar entre sinais de alta e de baixa.
// Score POSITIVO significa inclinacao para BAIXA (cada sinal de baixa soma,
// cada sinal de alta subtrai); 'dir' traduz isso.
export function scoreConfluence(technical) {
  const t = technical || {}
  const cs = { score: 0, signals: [] }
  const add = (i, v, s, pts) => { cs.score += pts; cs.signals.push({ i, v, s }) }

  if (t.rsi < 20) add('RSI', t.rsi?.toFixed(1), 'bearish', 25)
  else if (t.rsi < 30) add('RSI', t.rsi?.toFixed(1), 'bearish', 15)
  else if (t.rsi > 80) add('RSI', t.rsi?.toFixed(1), 'bullish', -25)
  else if (t.rsi > 70) add('RSI', t.rsi?.toFixed(1), 'bullish', -15)

  if (t.ema?.ema50 && t.current_price < t.ema.ema50) add('EMA50', 'preço abaixo', 'bearish', 15)
  else if (t.ema?.ema50) add('EMA50', 'preço acima', 'bullish', -15)

  if (t.ichimoku?.signal === 'bearish') add('Ichimoku', 'Abaixo da nuvem', 'bearish', 20)
  else if (t.ichimoku?.signal === 'bullish') add('Ichimoku', 'Acima da nuvem', 'bullish', -20)

  if (t.supertrend?.signal === 'bearish') add('Supertrend', 'preço abaixo', 'bearish', 20)
  else if (t.supertrend?.signal === 'bullish') add('Supertrend', 'preço acima', 'bullish', -20)

  if (t.macd?.signal_label === 'bearish') add('MACD Histograma', t.macd?.histogram?.toFixed(3), 'bearish', 20)
  else if (t.macd?.signal_label === 'bullish') add('MACD Histograma', t.macd?.histogram?.toFixed(3), 'bullish', -20)

  if (t.week52 && t.current_price) {
    const h = t.week52.high, l = t.week52.low, cp = t.current_price
    if (l && (cp - l) / l * 100 < 5) add('52W Low', '+' + (((cp - l) / l) * 100).toFixed(1) + '% acima', 'bullish', -15)
    else if (h && (h - cp) / h * 100 < 5) add('52W High', ((cp - h) / h * 100).toFixed(1) + '% abaixo', 'bearish', 15)
  }

  if (t.fibonacci?.levels && t.current_price) {
    const f = t.fibonacci.levels, cp = t.current_price
    // os niveis de retracao sao DECRESCENTES: o de 23.6% fica
    // ACIMA do de 38.2% em preco. Entao a zona altista testa
    // >= 38.2 e <= 23.6. Ate 10/10/2026 estava invertido e a
    // condicao era conjunto vazio: o sinal altista de Fibonacci
    // nunca disparou nenhuma vez, e nessa faixa o score ficava
    // 15 pontos baixista demais, numa escala onde 40 muda o
    // rotulo. O lado baixista sempre funcionou por sorte da
    // nomenclatura: 78.6% e o preco MENOR, entao a ordem
    // >= menor && <= maior coincidiu com a correta.
    // As 53 analises gravadas antes desta data tem o lado
    // altista morto: nao compare score de antes com o de depois.
    if (f['78.6'] && f['61.8'] && cp >= f['78.6'] && cp <= f['61.8']) add('Fibonacci', 'Zona 61.8-78.6%', 'bearish', 15)
    else if (f['23.6'] && f['38.2'] && cp >= f['38.2'] && cp <= f['23.6']) add('Fibonacci', 'Zona 23.6-38.2%', 'bullish', -15)
  }

  const abs = Math.min(Math.abs(cs.score), 100)
  const dir = cs.score > 0 ? 'bearish' : 'bullish'
  const label = abs >= 80 ? (dir === 'bearish' ? 'Forte baixa' : 'Forte alta')
    : abs >= 60 ? (dir === 'bearish' ? 'Baixista' : 'Altista')
    : abs >= 40 ? (dir === 'bearish' ? 'Levemente baixista' : 'Levemente altista')
    : 'Neutro'

  return { score: cs.score, signals: cs.signals, abs, dir, label }
}

// CLAW Exhaustion Score — mede se o movimento esta esticado e perto de virar.
// Nao diz direcao nem qualidade do ativo. Devolve tambem 'detalhes', que
// alimenta a lista "De onde vem o score" do card.
export function scoreExhaustion(technical) {
  const t = technical || {}
  const rsi = t.rsi || 50
  const bb = t.bollinger
  const macd = t.macd
  const st = t.supertrend
  const price = t.current_price || 0

  let ex = 0
  const det = []
  const add = (n, pts, nota) => { ex += pts; det.push({ n, pts, nota }) }
  const zero = (n, nota) => det.push({ n, pts: 0, nota })

  if (rsi < 20) add('RSI', 40, 'abaixo de 20')
  else if (rsi < 30) add('RSI', 25, 'abaixo de 30')
  else if (rsi > 80) add('RSI', 40, 'acima de 80')
  else if (rsi > 70) add('RSI', 25, 'acima de 70')
  else zero('RSI', 'faixa neutra \u2014 sem exaust\u00e3o')

  if (t.week52 && price > 0) {
    const h = t.week52.high, l = t.week52.low
    if (l && (price - l) / l * 100 < 3) add('52 semanas', 20, 'colado na m\u00ednima')
    else if (h && (h - price) / h * 100 < 3) add('52 semanas', 20, 'colado na m\u00e1xima')
    else if (l && (price - l) / l * 100 < 8) add('52 semanas', 10, 'perto da m\u00ednima')
    else if (h && (h - price) / h * 100 < 8) add('52 semanas', 10, 'perto da m\u00e1xima')
    else zero('52 semanas', 'longe dos extremos \u2014 sem exaust\u00e3o')
  }

  if (t.fibonacci?.levels && price > 0) {
    const lvls = Object.values(t.fibonacci.levels)
    const perto = lvls.reduce((a, b) => Math.abs(b - price) < Math.abs(a - price) ? b : a)
    const dist = Math.abs(perto - price) / price * 100
    if (dist < 1) add('Fibonacci', 20, 'sobre um n\u00edvel')
    else if (dist < 2) add('Fibonacci', 10, 'perto de um n\u00edvel')
    else zero('Fibonacci', 'longe de um n\u00edvel (>2%)')
  }

  if (bb?.upper && bb?.lower && price > 0) {
    const pos = (price - bb.lower) / (bb.upper - bb.lower)
    if (pos < 0 || pos > 1) add('Bollinger', 30, 'fora da banda')
    else if (pos <= 0.05 || pos >= 0.95) add('Bollinger', 30, 'na borda da banda')
    else if (pos <= 0.1 || pos >= 0.9) add('Bollinger', 15, 'perto da borda')
    else zero('Bollinger', 'dentro das bandas')
  }

  // 'perto de zero' tem que ser relativo ao PRECO. O corte de 0.5
  // em dolar valia 0.89% do preco da ETHA, 0.064% do SPY e 5% de
  // uma acao de $10: o componente quase nunca pontuava em papel
  // caro e quase sempre em papel barato. O corte de 0.9% reproduz
  // o comportamento antigo num papel de ~$56 e passa a valer igual
  // para todos. O numero segue arbitrario; o que deixou de ser
  // arbitrario e ele ser o MESMO em todo ativo. Normalizar por ATR
  // seria melhor ainda, mas depende de atr_pct chegar, e a propria
  // exaustao ainda nao tem vantagem medida — ver o card de acertos.
  if (macd?.macd !== undefined && macd?.signal !== undefined && price > 0) {
    if (Math.abs(macd.histogram || 0) / price * 100 < 0.9) add('MACD', 20, 'histograma perto de zero')
    else zero('MACD', 'histograma forte \u2014 sem exaust\u00e3o')
  }

  if (st?.value && price > 0) {
    const dist = Math.abs(price - st.value) / price * 100
    if (dist < 1) add('Supertrend', 10, 'pre\u00e7o colado no n\u00edvel')
    else zero('Supertrend', 'longe do n\u00edvel')
  }

  const score = Math.min(ex, 100)
  const sobrevendido = rsi < 30
  const sobrecomprado = rsi > 70
  let bounce, label
  if (score >= 80) { bounce = 'MUITO ALTO'; label = sobrevendido ? 'Sobrevendido extremo' : sobrecomprado ? 'Sobrecomprado extremo' : 'Movimento exausto' }
  else if (score >= 60) { bounce = 'ALTO'; label = sobrevendido ? 'Sobrevendido' : sobrecomprado ? 'Sobrecomprado' : 'Sinais de exaust\u00e3o' }
  else if (score >= 40) { bounce = 'MODERADO'; label = 'Sinais de fadiga' }
  else if (score >= 20) { bounce = 'BAIXO'; label = 'Pouco sinal de exaust\u00e3o' }
  else { bounce = 'MUITO BAIXO'; label = 'Sem sinal de exaust\u00e3o' }

  return { score, detalhes: det, label, bounce }
}

// Regua do CLAW Advanced Analytics. Extraida do JSX para que a gravacao do
// registro e a tela usem exatamente o mesmo calculo.
export function scoreAvancado(a) {
  if (!a || a.error) return null
  const motivos = [
    a.adx && {label:"ADX", val: a.adx.signal==="strong" ? 15 : 5, max:15},
    a.vwap && {label:"VWAP", val: a.vwap.signal==="above" ? 15 : 3, max:15},
    a.keltner && {label:"Keltner", val: a.keltner.signal==="neutral" ? 6 : a.keltner.signal==="oversold" ? 10 : 2, max:10},
    a.anchored_vwap && {label:"A-VWAP", val: a.anchored_vwap.signal==="above" ? 10 : 3, max:10},
    // forca = quantos dias de volume normal entraram (+) ou sairam (-) em 10 pregoes.
    // cortes tirados da distribuicao real dos ativos (p25 ~0.10, p75 ~0.40), nao de chute.
    // regua trocada em 30/09/2026: os advanced_score gravados antes disso usaram o binario 15/3.
    // sem forca (backend antigo no ar), cai no binario de antes.
    a.obv && {label:"OBV", val: (a.obv.forca === undefined || a.obv.forca === null)
      ? (a.obv.trend==="bullish" ? 15 : 3)
      : (a.obv.forca >= 0.40 ? 15 : a.obv.forca >= 0.10 ? 12 : a.obv.forca > -0.10 ? 9 : a.obv.forca > -0.40 ? 6 : 3), max:15},
    a.mfi && {label:"MFI", val: a.mfi.signal==="oversold" ? 8 : a.mfi.signal==="neutral" ? 6 : 3, max:10},
    // o estimador do backend subestima tendencia (ver comentario no main.py).
    // medido em 12 anos e 9 ativos (acao, ouro, titulo, cripto, ETF): a distribuicao
    // do Hurst e quase igual entre classes, mas desloca com o regime — o p90 anda de
    // 0.513 (2025) a 0.594 (2020), e corte fixo dispara em 12% dos dias num ano e em
    // 0.6% noutro. Por isso a nota sai do pct que o backend manda: a posicao do valor
    // de hoje na distribuicao do proprio ativo em 2 anos, que se recalibra sozinha e
    // nao precisa mais ser revista. Sem pct, cai nos cortes agrupados dos 12 anos.
    // Regua trocada em 30/09/2026, como a do OBV acima. O rotulo da tela le o absoluto.
    a.hurst && {label:"Hurst", val: (a.hurst.pct === undefined || a.hurst.pct === null)
      ? (a.hurst.value >= 0.55 ? 10 : a.hurst.value >= 0.50 ? 8 : a.hurst.value >= 0.45 ? 6 : a.hurst.value >= 0.38 ? 4 : 3)
      : (a.hurst.pct >= 90 ? 10 : a.hurst.pct >= 75 ? 8 : a.hurst.pct >= 50 ? 6 : a.hurst.pct >= 25 ? 4 : 3), max:10},
    a.ulcer_index != null && {label:"Ulcer", val: a.ulcer_index < 5 ? 10 : a.ulcer_index < 15 ? 6 : 2, max:10},
    a.garch_vol_5d != null && {label:"GARCH", val: a.garch_vol_5d < 3 ? 5 : a.garch_vol_5d < 6 ? 3 : 1, max:5},
  ].filter(Boolean).sort((x,y) => (y.val/y.max) - (x.val/x.max))
  const bruto = motivos.reduce((acc,x) => acc + x.val, 0)
  const total = motivos.reduce((acc,x) => acc + x.max, 0)
  const fs = total > 0 ? Math.round(bruto / total * 100) : 0
  // a lista de conflitos tem UMA checagem, entao conf so pode
  // valer 0 ou 1 e o teto de 55 com 'conf >= 2' nunca se aplicou:
  // fsAj era sempre igual a fs. Corrigido para >= 1 em 10/10/2026.
  // Se outras checagens voltarem para a lista, o limiar sobe junto.
  const conf = [
    a.vwap?.signal==="above" && a.anchored_vwap?.signal!=="above",
  ].filter(Boolean).length
  const fsAj = conf >= 1 ? Math.min(fs, 55) : fs
  return {motivos, bruto, total, fs, fsAj, conf}
}

// Nota de sobrevenda do DCA Intelligence. Mesma formula do rankingLocal,
// extraida para que o registro e a tela nao possam divergir.
export function scoreOversold(rsi, macdSignal) {
  const r = parseFloat(rsi)
  if (isNaN(r)) return null
  const base = Math.max(0, Math.min(100, (70 - r) / 45 * 100))
  const bonus = macdSignal === "bullish" ? 10 : 0
  return Math.round(Math.min(100, Math.max(0, base + bonus)))
}

// Nota de melhora do preco medio (objetivo dca do DCA Intelligence).
// Depende do preco medio DO INVESTIDOR: mede a posicao dele no ativo,
// nao uma propriedade do ativo. Mesma formula do rankingLocal.
export function scoreDca(pctAbaixo, rsi) {
  const pc = parseFloat(pctAbaixo), r = parseFloat(rsi)
  if (isNaN(pc) || isNaN(r)) return null
  const base = pc > 0 ? Math.min(70, Math.sqrt(pc) * 14) : 0
  const tim = Math.max(0, Math.min(30, (70 - r) / 40 * 30))
  return Math.round(Math.min(100, Math.max(0, base + tim)))
}
